import { useState } from "react";
import {
  Container,
  Card,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  StepButton,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import GroupSharpIcon from "@material-ui/icons/GroupSharp";
import FaceSharpIcon from "@material-ui/icons/FaceSharp";
import WebSharpIcon from "@material-ui/icons/WebSharp";
import HighlightSharpIcon from "@material-ui/icons/HighlightSharp";
import RssFeedSharpIcon from "@material-ui/icons/RssFeedSharp";
import StoreMallDirectorySharpIcon from "@material-ui/icons/StoreMallDirectorySharp";
// import whiteLogo from "../../assets/white_logo.png";

import "./index.less";

export default function Roadmap() {
  const [activeStep, setActiveStep] = useState(4);
  const steps = [
    { icon: GroupSharpIcon, date: "2021-05-02", text: "# Team Assembled" },
    {
      icon: FaceSharpIcon,
      date: "2021-05-10",
      text: "# KungFu Heroes Prototype Completed",
    },
    {
      icon: WebSharpIcon,
      date: "2021-05-23",
      text: "# Website Building Started",
    },
    {
      icon: HighlightSharpIcon,
      date: "2021-06-10",
      text: "# Beta Testing",
    },
    {
      icon: RssFeedSharpIcon,
      date: "2021-06-20",
      text: "# Social Media Launched",
    },
    {
      icon: RssFeedSharpIcon,
      date: "2021-07-01",
      text: "# Discord Group Set Up",
    },
    {
      icon: RssFeedSharpIcon,
      date: "2021-07-10",
      text: "# Public Release",
    },
  ];

  const milestones = [
    { value: "20", text: "We buy our developers and angel investors dinner." },
    { value: "30", text: "Free Treasure Hunt game initiates." },
    {
      value: "50",
      text: "One BAYC Ape will be given to one KungFu Hero randomly.",
    },
    {
      value: "70",
      text: "One BAYC Ape will be given to one KungFu Hero randomly.",
    },
    {
      value: "80",
      text: "5% of sale proceeds to set up KungFu community wallet.",
    },
    {
      value: "90",
      text: "Collaboration with Sandbox to build KungFu World metaverse.",
    },
    {
      value: "100",
      text: "One Cryptopunk will be given to a KungFu Hero randomly. \n New Roadmap on follow-up projects and collaborations",
    },
  ];

  return (
    <div className="roadmap">
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography component="div" variant="h4" className="timeline-title">
              Timeline
            </Typography>
            <div className="milestones">
              {steps.map((step, index) => {
                return (
                  <div className="single-milestone" key={index}>
                    <div className="percent">{step.date}</div>
                    <div className="text">{step.text}</div>
                  </div>
                );
              })}
            </div>
            {/* <Stepper
              activeStep={activeStep}
              orientation="vertical"
              className="roadmap-step"
            >
              {steps.map((step, index) => (
                <Step key={index} disabled>
                  <StepLabel
                    StepIconComponent={({ completed }) => (
                      <step.icon color={completed ? "secondary" : "inherit"} />
                    )}
                  >
                    <div className="step-desc">
                      <div className="step-date">{step.date}</div>
                      <div className="step-text">{step.text}</div>
                    </div>
                  </StepLabel>
                </Step>
              ))}
            </Stepper> */}
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid
              container
              alignContent="flex-end"
              direction="column"
              className="milestones-container"
            >
              <div className="milestones-logo">
                {/* <img src={whiteLogo} width="100%" alt="" /> */}
                <Typography
                  component="div"
                  variant="h4"
                  className="timeline-title"
                >
                  ROADMAP Activations
                </Typography>
              </div>
              <div className="milestones">
                {milestones.map((milestone, index) => {
                  return (
                    <div className="single-milestone" key={index}>
                      <div className="percent">{milestone.value}%</div>
                      <div className="text">{milestone.text}</div>
                    </div>
                  );
                })}
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
